export default __webpack_public_path__ + "static/media/IBMPlexSans-Bold.7f9491c8.ttf";